import { useAuth } from '@/app/auth';
import Button from '@/components/Button/Button';

function GoogleGlyph() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 18 18" aria-hidden="true">
      <path
        d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.209 1.125-.8436 2.0782-1.7972 2.7164v2.2581h2.9087c1.7018-1.5668 2.6849-3.8741 2.6849-6.615z"
        fill="#4285F4"
      />
      <path
        d="M9 18c2.43 0 4.4673-.8059 5.9564-2.1804l-2.9087-2.2581c-.8059.54-1.8368.8595-3.0477.8595-2.344 0-4.3282-1.5831-5.0359-3.71H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z"
        fill="#34A853"
      />
      <path
        d="M3.9641 10.71c-.18-.54-.2823-1.1168-.2823-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.997 8.997 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.9641 10.71z"
        fill="#FBBC05"
      />
      <path
        d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.4259 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.9641 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"
        fill="#EA4335"
      />
    </svg>
  );
}

export default function LoginScreen() {
  const { signInWithGoogle, signInInProgress, signInError } = useAuth();

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-(--bg-app-solid) px-4">
      <div className="flex w-full max-w-sm flex-col items-center text-center">
        <h1 className="font-display mb-3 text-4xl font-bold tracking-wider text-(--text-primary)">Jums Dashboard</h1>
        <p className="mb-8 text-sm text-(--text-secondary)">Sign in with your Google account to access the dashboard.</p>
        <Button
          variant="primary"
          size="lg"
          loading={signInInProgress}
          leadingIcon={signInInProgress ? null : <GoogleGlyph />}
          onClick={() => {
            void signInWithGoogle();
          }}
          className="w-full"
        >
          {signInInProgress ? 'Signing in…' : 'Sign in with Google'}
        </Button>
        {signInError && (
          <p
            role="alert"
            className="mt-4 rounded-md border border-(--accent-danger)/30 bg-(--accent-danger)/10 px-3 py-2 text-xs text-(--accent-danger)"
          >
            {signInError}
          </p>
        )}
      </div>
    </div>
  );
}
